import React from 'react';
import {connect} from 'react-redux';
import {filterLanguages} from "../../state/actions/app";

const {$}=window

const mapStateAsProps = state=>({
    vulnerableOnly: state.languagesFilter.vulnerableOnly,
    toggledLanguages: state.languagesFilter.toggledLanguages,
	languages: Object.keys(state.projectInfo.licensing.summary.byLanguage),
})

const mapDispatchAsProps = dispatch=>({
    toggle: (languages)=>dispatch(filterLanguages(languages))
})

const LanguagesFilter=(props)=>{
    const {languages}=props;

    const filtersRefs={};

    const filterAction=(target,language)=>{
		if(!language) props.toggle();
		else if(props.toggledLanguages.includes(target)){
            const toggledLanguages=props.toggledLanguages.filter(item=>item!==target)
            $("div[data-language='"+target+"']").show()
            props.toggle(toggledLanguages);
        } 
		else if(languages.length-props.toggledLanguages.length>1) {
            const toggledLanguages=props.toggledLanguages.slice();
            toggledLanguages.push(target);
            $("div[data-language='"+target+"']").hide()
            props.toggle(toggledLanguages);
        }
		else {
			$("#filter-"+target).popover('toggle'); 
			filtersRefs[target].checked=!filtersRefs[target].checked;
			return
		}
	}
    
    const populateFilter=()=>{
        if (languages.length===1){
            return ""
        }
		return languages.map(language=>{
			return (
			<div key={"key"+language} className="btn m-1 pt-0">
				<div className="custom-control custom-switch">
					<input data-trigger="focus" data-content="You need at least one language active." ref={input=>filtersRefs[language]=input} type="checkbox" className="custom-control-input" id={"filter-"+language} onChange={()=>filterAction(language,true)} defaultChecked={!props.toggledLanguages.includes(language)}/>
					<label className="custom-control-label" htmlFor={"filter-"+language}>{language}</label>
				</div>
			</div>)
			
		})
    }
    
    return(
        <div className="language-filter d-flex flex-wrap col-md-6 justify-content-end">
            <div className="btn m-1 pt-0" >
                <div className="custom-control custom-switch">
                    <input type="checkbox" ref={input=>filtersRefs.vulnerable=input} className="custom-control-input" id="vulnerable-only" onChange={()=>filterAction("vulnerable")} defaultChecked={props.vulnerableOnly}/>
                    <label className="custom-control-label" htmlFor="vulnerable-only">Show issues only</label>
                </div>
            </div>
            {populateFilter()}
        </div>
    )

}


export default connect(mapStateAsProps, mapDispatchAsProps)(LanguagesFilter)